import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

// TODO: Replace with your Firebase configuration
// Get this from Firebase Console > Project Settings > General > Your apps
const firebaseConfig = {
  apiKey: "AIzaSyDHUO2-dyXo_lLAYiXtSg_k3SlMergQZHM",
  authDomain: "family-loan-mm.firebaseapp.com",
  projectId: "family-loan-mm",
  storageBucket: "family-loan-mm.firebasestorage.app",
  messagingSenderId: "122006562090",
  appId: "1:122006562090:web:3419fb27c757926afc6a53",
  measurementId: "G-NVRHK70MYD"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Authentication and get a reference to the service
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();

// Initialize Cloud Firestore and get a reference to the service
export const db = getFirestore(app);

export default app;
